import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
import TableHeaderHtmlCustom from '../../../../components/common/customTable/TableHeaderHtmlCustom';
import { TableCompHead } from '../../../../components/ui';
import { useQuery } from '../../../../hooks/UseQuery';
import { getColumnLength } from '../../helpers/utils';

interface IProps {
  moduleData: any;
  isView: boolean;
}
const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
};

const theadData = [
  [
    { text: 'SNO.' },
    { text: 'Employee`s Name.', style: { minWidth: '200px' } },
    { text: 'Description', style: { minWidth: '200px' } },
    { text: 'Payment Type', style: { minWidth: '200px' } },
    { text: 'SP ALLOWANCE', style: { minWidth: '80px' } },
    { text: 'SALARY', style: { minWidth: '80px' } },
    { text: 'DUTY', style: { minWidth: '80px' } },
    { text: 'Sun OT', style: { minWidth: '80px' } },
    { text: 'Total', style: { minWidth: '80px' } },
    { text: 'OT', style: { minWidth: '80px' } },
    { text: 'DUTY AMT', style: { minWidth: '80px' } },
    { text: 'OT AMT', style: { minWidth: '80px' } },
    { text: 'TOTAL', style: { minWidth: '80px' } },
    { text: 'ADVANCE', style: { minWidth: '80px' } },
    { text: 'TOTAL', style: { minWidth: '80px' } },
    { text: 'TEA', style: { minWidth: '80px' } },
    { text: 'PF/ESI', style: { minWidth: '80px' } },
    { text: 'cheque Payment', style: { minWidth: '80px' } },
    { text: 'NET PAY', style: { minWidth: '80px' } },
    { text: 'previous bal', style: { minWidth: '80px' } },
    { text: 'Cash Payable', style: { minWidth: '80px' } },
    { text: 'Cheque Amount', style: { minWidth: '80px' } },
    { text: 'REMARKS', style: { minWidth: '200px' } },
  ],
];

const THead = ({ moduleData, isView }: IProps) => {
  const annual_date = useQuery('annual_date');

  return (
    <thead>
      <TableCompHead
        colSpan={23}
        rowSpan={1}
        labels={[]}
        values={[]}
        heading={`SALARY FOR THE MONTH OF ${annual_date}`}
      />
      <tr>
        <th colSpan={3}>No of days</th>
        <th>{getColumnLength(annual_date || '')}</th>
      </tr>
      <TableHeaderHtmlCustom tableHeaderObj={theadData} customStyle={style1} />
    </thead>
  );
};

export default THead;
